import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { eur } from "../api";
import { usePageSeo } from "../components/common";

export default function Tarifs() {
  usePageSeo({
    title: "Tarifs des tirages et prestations",
    description: "Les tarifs des tirages intuitifs, séances énergétiques, Entre Lui et Moi et du Guide Visuel du Tarot de Noëmie, ta sorcière préférée.",
    path: "/tarifs",
  });
  const [guidance, setGuidance] = useState([]);
  const [energetique, setEnergetique] = useState([]);
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    api.get("/services?category=guidance").then((r) => setGuidance(r.data)).catch(() => {});
    api.get("/services?category=energetique").then((r) => setEnergetique(r.data)).catch(() => {});
    api.get("/offers/config").then((r) => setOffers(r.data)).catch(() => {});
  }, []);

  const Row = ({ name, price, to, note }) => (
    <Link to={to} className="flex items-center justify-between gap-4 py-3.5 border-b border-[#7A5D58]/10 group">
      <span className="text-[#5A3A4B] font-medium">{name}{note && <span className="block text-xs text-[#7A5D58] font-normal">{note}</span>}</span>
      <span className="font-serif text-xl text-[#5A3A4B] inline-flex items-center gap-2 shrink-0">{price}<ArrowRight size={15} className="text-[#C9A56A] opacity-0 group-hover:opacity-100 transition" /></span>
    </Link>
  );

  return (
    <div className="home-dark min-h-[80vh]">
      <div className="container-x py-12 sm:py-20 fade-up max-w-3xl">
        <div className="eyebrow mb-3 !text-[#DFC07B]">Tarifs</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#F9F5EE]">Tarifs des tirages et prestations</h1>
        <p className="mt-4 text-[#CBB9CF]">Toutes les prestations sont réalisées à distance, sans appel ni visio, avec un compte rendu écrit.</p>
        <div className="gold-divider my-7 w-28" />

        <div className="card-soft p-6 sm:p-7 mb-6">
          <h2 className="font-serif text-2xl text-[#5A3A4B] mb-2">Mes tirages intuitifs</h2>
          {guidance.map((s) => <Row key={s.slug} name={s.name} price={eur(s.price_cents)} to={`/guidances/${s.slug}`} note={s.duration_minutes ? `${s.duration_minutes} min` : null} />)}
        </div>
        <div className="card-soft p-6 sm:p-7 mb-6">
          <h2 className="font-serif text-2xl text-[#5A3A4B] mb-2">L'Énergétique</h2>
          {energetique.map((s) => <Row key={s.slug} name={s.name} price={eur(s.price_cents)} to={`/energetique/${s.slug}`} note={s.duration_minutes ? `${s.duration_minutes} min` : null} />)}
        </div>
        {offers && (
          <div className="card-soft p-6 sm:p-7">
            <h2 className="font-serif text-2xl text-[#5A3A4B] mb-2">Offres & contenus</h2>
            <Row name="Entre Lui et Moi" note="Abonnement mensuel · courrier physique" price={`${eur(offers.entre_lui.price_cents)}/mois`} to="/entre-lui-et-moi" />
            <Row name="Le Grimoire Visuel du Tarot" note={offers.guide.promo_on ? `Offre de lancement (au lieu de ${eur(offers.guide.price_normal_cents)})` : "Produit numérique"} price={eur(offers.guide.current_price_cents)} to="/guide-du-tarot" />
          </div>
        )}
      </div>
    </div>
  );
}
